<template>
    <div>
        <div class="row">
            <div class="col">
                <Progress :pre-gate="prev"></Progress>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h2>Nearly done</h2>
                <p class="paragraph">
                    We’re ready to finalise your results, but we want to give you some relevant guides, tools and reports to better inform your journey to EV.<br>
                    Provide us with a bit more information and we’ll recommend the right content for you.<br>
                    Alternatively, you can go back to <a href="#" @click="onBack">review and amend your answers</a>.
                </p>

                <p class="alert alert-danger" v-if="errors.length">Please complete the highlighted fields</p>

                <form action="#" method="post" class="form" novalidate @submit="formSubmit">
                    <label for="firstname" class="label label--text">
                        First name*
                        <input type="text" name="firstname" v-model="firstname"  id="firstname" class="input input--text" required>
                    </label>
                    <label for="lastname" class="label label--text">
                        Last name*
                        <input type="text" name="lastname" v-model="lastname" id="lastname" class="input input--text" required>
                    </label>
                    <label for="company" class="label label--text">
                        Company*
                        <input type="text" name="company" v-model="company" id="company" class="input input--text" required>
                    </label>
                    <label for="email" class="label label--text">
                        Email*
                        <input type="text" name="email" v-model="email" id="email" class="input input--text" required>
                    </label>
                    <label for="fleetsize" class="label label--text">
                        Fleet size*
                        <div class="pretty-select">
                            <select name="fleetsize" v-model="fleetsize" id="fleetsize">
                                <option value="Small Business (1-4)">1-4</option>
                                <option value="SME (5-25)">5-25</option>
                                <option value="Corporate (26-499)">26-499</option>
                                <option value="Strategic (500+)">500+</option>
                                <option value="CV">Commercial Vehicles</option>
                                <option value="Public Sector">Public Sector (1 - 500+)</option>
                                <option value="Driver">Driver</option>
                            </select>
                        </div>
                    </label>
                    <label for="fleetcomp" class="label label--text">
                        Fleet composition*
                        <div class="pretty-select">
                            <select name="fleetcomp" v-model="fleetcomp" id="fleetcomp">
                                <option value="Cars">Cars</option>
                                <option value="Vans">Vans</option>
                                <option value="Mixed">Mixed</option>
                            </select>
                        </div>
                    </label>

                    <div>
                        <div class="pretty-radio">
                            <span class="pretty-radio__title" id="optin">Email marketing* | </span>
                            <label class="label--radio" for="optin-in">
                                <input class="input" type="radio" name="optin" v-model="optin"  id="optin-in" value="true">
                                <span class="pretty-radio__title">Opt-in</span>
                            </label>
                            <label class="label--radio" for="optin-out">
                                <input class="input" type="radio" name="optin"  v-model="optin" id="optin-out" value="false">
                                <span class="pretty-radio__title">Opt-out</span>
                            </label>
                        </div>
                        <br>
                        <p class="paragraph--small text-muted">Volkswagen Financial Services | Fleet (VWFS | Fleet) would like to send you information about its products and services. If you agree, please tick to say how you would like to be contacted. You can change your preferences at any time by updating them online or writing to or calling us. If you do opt-out, you may still see some generic, non-personalised advertising when you are using digital channels.</p>
                        <br>
                    </div>

                    <input type="submit" value="View results" class="button button--solid" :disabled="submitting">

                    <div>
                        <br>
                        <p class="paragraph--small text-muted">Fields marked with an asterisk are required.</p>
                        <p class="paragraph--small text-muted"><strong>About us and Privacy</strong></p>
                        <p class="paragraph--small text-muted">VWFS | Fleet is collecting this personal data about you (“your information”) in order to respond to your enquiry.</p>
                        <p class="paragraph--small text-muted">The privacy and security of your personal information is very important to us, so we want to assure you that your information will be properly managed and protected when it's in our hands.</p>
                        <p class="paragraph--small text-muted">Further information on how your information is used, how we maintain the security of your information, your right to access information we hold on you and details of relevant third party and Volkswagen Group companies for data sharing purposes is in our <a href="https://www.vwfsfleet.co.uk/data-privacy-policy" target="_blank">Privacy Policy</a> or can be requested from <a href="mailto:DPO@vwfs.co.uk">DPO@vwfs.co.uk</a></p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<style lang="stylus" scoped>
    .error
        &.pretty-select
            border-color #ff4963 !important
            border-width 2px !important

        &.pretty-radio
            .pretty-radio__title:before
                border-color #ff4963 !important

        input
            border-color #ff4963 !important
            border-width 2px !important
    .form
            display flex
            flex-wrap wrap
            margin-right -1.5rem

            .label
                flex 0 0 100%

                display flex
                flex-direction column
                max-width 50%
                margin-bottom 2.5rem
                padding-right 1.5rem

                @media(max-width 767px)
                    max-width 100%

                &--textarea
                    max-width 100%

            .input
                margin-top 5px
                font-family VWAGTheSansRegular
                font-size 15px
                font-weight normal

                &[type=text],
                &[type=textarea]
                    border solid 1px #a8adb3
                    box-shadow none
                    border-radius 0
                    width 100%
                    padding 0 1rem

                &--text
                    height 4.4rem

                &--textarea
                    min-height 25rem

            // Pretty Radio box
            .pretty-radio
                flex 0 0 100%
                display flex
                justify-items flex-start

                @media(max-width 767px)
                    flex-wrap wrap

                &__title
                    margin-right 1.5rem

                    @media(max-width 767px)
                        flex 0 0 100%
                        margin-bottom 5px


                .label--radio
                    flex 0 0 auto
                    max-width unset
                    display flex
                    position relative
                    overflow hidden
                    flex-direction row
                    justify-items  flex-start
                    align-items center
                    padding-left 3.5rem
                    padding-right 0
                    cursor pointer

                    &:not(:last-child)
                        margin-right 1.5rem

                    .input
                        position absolute
                        left -9999em
                        max-width auto
                        width auto

                    // check markers
                    span
                        &:before
                            display block
                            position absolute
                            left 0
                            top 50%
                            transform translateY(-50%)
                            content ''
                            width 2.4rem
                            height 2.4rem
                            border solid 1px #a8adb3
                            box-shadow none
                            border-radius 50%
                            cursor pointer

                    .input:checked + span
                        &:after
                            display block
                            position absolute
                            left 5px
                            top 50%
                            transform translateY(-50%)
                            content ''
                            width 1.4rem
                            height 1.4rem
                            box-shadow none
                            background-color $color-blue-petrol
                            border-radius 50%
                            cursor pointer

            // PRETTY SELECTS
            .pretty-select
                border 1px solid #a8adb3
                position relative
                overflow hidden
                margin-top 5px

                &.focused
                    border-color $color-blue-petrol

                &:after
                    content ''
                    position absolute
                    z-index 10
                    right 0
                    top 0
                    height 100%
                    width 40px
                    background url('~@/assets/img/menu-arrow-down.svg') no-repeat #fff 50% 50%
                    pointer-events none
                    cursor pointer

                select
                    padding 0 8px
                    height 42px
                    width 100%
                    border none
                    box-shadow none
                    background transparent
                    background-image none
                    padding-right 40px !important
                    -webkit-appearance none
                    -moz-appearance none
                    appearance none
                    color #4c5356

                    &:focus,
                    &:active
                        border none
                        outline none

                    &::-ms-expand
                        display none
</style>
<script>
    import Progress from './partials/Progress'
    import axios from 'axios';
    import qs from 'qs';
    import VueScrollTo from "vue-scrollto";
    import AnswerPreload from "../../services/AnswerPreload";

    export default {
        name: "Gate",

        data: function () {
            return {
                firstname: null,
                lastname: null,
                email: null,
                company: null,
                fleetsize: null,
                fleetcomp: null,
                optin: null,
                endpoint: process.env.VUE_APP_PARDOT_PROXY,
                pardotEndpoint: process.env.VUE_APP_GATE_URL,
                submitting: false,

                required: [
                    'firstname',
                    'lastname',
                    'email',
                    'company',
                    'fleetsize',
                    'fleetcomp',
                    'optin',
                    'range',
                    'tool_url'
                ],
                errors: []
            }
        },

        components: {
            Progress,
        },

        computed: {
            prev(){
                // there are 2 points at which the results can be presented
                // so will we just fetch the last question number for the progress bar
                return this.$store.state.previous[this.$store.state.previous.length - 1];
            },
            range() {
                let range = Math.round((this.$store.getters.getOverallReadiness / this.$store.getters.getMaxWeights.total * 4) + 1)

                // ensure start and end values are correctly limited
                if (range > 5) {
                    range = 5;
                }
                if (range < 1) {
                    range = 1
                }

                return range;
            },
            adminUrl() {
                return AnswerPreload.getAdminUrl(this.$store);
            }
        },

        methods: {
            onBack() {
                this.$store.dispatch("back");
            },

            formSubmit(e) {
                e.preventDefault();
                this.errors = [];
                this.submitting = true;

                let errors = this.$el.querySelectorAll('.error');
                if (errors.length) {
                    Array.from(errors).forEach(function(el){
                       el.classList.remove('error');
                    });
                }

                let valid = true,
                    vm = this;

                this.required.forEach(function(field){
                    if (vm[field] === null || vm[field] === '') {
                        vm.errors.push(field)
                        valid = false;
                        vm.submitting = false;
                        vm.$el.querySelector('#' + field).parentElement.classList.add('error');
                    }
                });

                if (valid === true) {
                    let pardot = axios.create();

                    pardot.post(this.endpoint,
                        qs.stringify({
                            firstname: this.firstname,
                            lastname: this.lastname,
                            email: this.email,
                            company:this.company,
                            fleetsize: this.fleetsize,
                            fleetcomp: this.fleetcomp,
                            range: this.range,
                            optin: this.optin,
                            pardot: this.pardotEndpoint,
                            tool_url: this.adminUrl,
                            required: this.required,
                        })
                    )
                    .then(function (response) {
                        vm.submitting = false;
                        let data = response.data;
                        if (data.success) {
                            vm.$gtag.logStep(
                                'EV Maturity Tool - Gate',
                                'success'
                            );
                            vm.$store.commit('setGated', false);
                            vm.$store.dispatch('next');
                            VueScrollTo.scrollTo('#app', 1);
                        } else {
                            vm.$gtag.logStep(
                                'EV Maturity Tool - Gate',
                                'fail'
                            );
                            data.errors.forEach(function(field){
                                vm.errors.push(field)
                                vm.$el.querySelector('#' + field).parentElement.classList.add('error')
                            });
                        }
                    });
                }
            }
        },

        mounted() {
            if (!this.$store.state.gatedLogged) {
                this.$gtag.logPageLoad('EV Maturity Tool - Gated');
                this.$store.commit('setGatedLogged', true);
            }
        }
    }
</script>